import { assign, createMachine } from 'xstate';
import * as notificationService from '@/services/notification';
import i18n from '@/i18n';
import { finishAnalysis } from '@/api/analyses';

/**
 * State machine to control the finished status of monitoring
 * if the monitoring is active and the user has the backoffice admin authorization
 * she can stop the monitoring
 */
export const machine = (finished: boolean, isAdminUser: boolean) => createMachine(
  {
    initial: 'initial',
    context: {
      finished: finished,
      hasAdminAuthorization: isAdminUser,
      clickable: false,
    },
    states: {
      'initial': {
        always: [
          {
            cond: 'canFinish',
            target: 'monitoring_finishable',
          },
          {
            target: 'readonly',
          },
        ]
      },
      'readonly': {
        entry(ctx) {
          ctx.clickable = false;
        },
        type: 'final',
      },
      'monitoring_finishable': {
        entry(ctx) {
          ctx.clickable = true;
        },
        on: {
          'FINISH': 'confirm_finish'
        },
      },
      'confirm_finish': {
        entry(ctx) {
          ctx.clickable = false;
        },
        on: {
          'CONFIRM': 'finishing',
          'CANCEL': 'monitoring_finishable',
        }
      },
      'finishing': {
        invoke: {
          src: 'finishMonitoring',
          onDone: {
            target: 'readonly',
            actions: assign({ finished: true })
          },
          onError: {
            target: 'monitoring_finishable',
            actions: ['notifyError'],
          }
        },
      }
    }
  },
  {
    services: {
      async finishMonitoring(ctx, event) {
        return await finishAnalysis(event.uuid);
      }
    },
    actions: {
      notifyError(ctx, event) {
        ctx.clickable = true;
        notificationService.addErrorNotification(
          i18n.t('monitoring.finish-warning.error-message',
            {
              message: JSON.stringify(event.data.response?.data || event.data.message)
            }) as string);
      }
    },
    guards: {
      canFinish(ctx) {
        return ctx.hasAdminAuthorization && !ctx.finished;
      }
    }
  }
);
